/// <amd-module name="Analytics/Queries/PingServiceQuery" />
import { AnalyticsCacheableQueryBase } from "Analytics/Common/AnalyticsCacheableQueryBase";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";

/**
 * A sentinel query used to determine whether or not the Analytics Service is operational.
 * Usage MUST be project scoped for features exposed for public project scenarios.
 * Also provides an early signal of user-permission issues when executed at project scope.
 */
export default class PingServiceQuery extends AnalyticsCacheableQueryBase<void> {
    private static generateQueryOptions(projectId?: string): ODataQueryOptions {
        return {
            project: projectId,
            entityType: "Dates",
            oDataVersion: latestODataVersion,
            $top: "1",
            $select: "DateSK"
        };
    }

    constructor(command: string, projectId?: string) {
        super(command, PingServiceQuery.generateQueryOptions(projectId));

        // The ping query is for implementation plumbing. It does not expose insights which matter to the customer.
        // Ping Queries should never be used to track usage.
        this.setAutomationMode(true);
    }

    public getQueryName(): string {
        return "PingServiceQuery";
    }
}
